"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when the user's subscription is not active
 * @param {string} message
 */
class SubscriptionNotActiveError extends client_library_1.ExtendableError {
    constructor(message) {
        super(message);
    }
}
exports.default = SubscriptionNotActiveError;
//# sourceMappingURL=SubscriptionNotActiveError.js.map